import enLocale from 'element-ui/lib/locale/lang/en'
export default {
    ...enLocale,
    list: {
        return: 'return',

        download: 'Down',
        pass: 'Pass',
        rawdata: 'RawDate',
        header: 'Header',
        whyspam: 'Whyspam',
        show: 'Digest',
        body: 'Body',
        origin: 'Original body',
        info: 'Participle',
        trainspam: 'Spam',
        trainnormal: 'Normai',
        cancel_send: 'cancel Send',
        immediate_delivery: 'immediate_delivery',
        bath_send: 'bath send',

        cc: 'CC',
        detail: 'detailed info',

        // 查找条件
        from: 'From',
        to: 'To',
        data: 'Date',
        record_time: "record_time",
        attach: 'Attach',
        envfrom: 'envfrom',
        envrcpt: 'envrcpt',
        id: 'id',
        ip: 'ip',
        replyto: 'replyto',
        hide: 'hide',
        num: 'num',

        bte: 'black this email',
        wte: 'white this email',
        bte1: 'black to this email',
        wte1: 'white to this email',
        bti: 'black this ip',
        wti: 'white this ip',
        wti1: 'Delete ip black',
        bti1: 'Delete ip white',
        fu: 'Attach',
        // 实时投递日志
        sender: 'Sending account inquiry',
        receiver: 'Collect account inquiry',
        sender1: 'The local dispatch failed',
    },
    tan: {
        up: 'uploading',
        confirm1: 'successfully added',
        cancel1: 'Cancel the add',

        confirm: 'confirm',
        cancel: 'cancel',

        confirm2: 'successfully cancel',

        cancel2: 'Cancel the add',
        tan1: 'add this email into blacklist? ',
        tan2: 'add this email into whitelist?',
        tan3: 'add this ip into blacklist? ',
        tan4: ' add this ip into whitelist?',
        tan11: 'add this email into blacklist?',
        tan12: ' add this ip into blacklist?',
        tan13: ' Delete this ip from blacklist?',

        bte: '(This email already in blacklist)',
        wte: '(This email already in whitelist)',
        wti1: '(This ip already in blacklist)',
        bti1: '(This ip already in whitelist)',
        profile: '确定要配置Are you sure you want to configure the certificate file?',
        config_success: 'config Success',
        reading_pre: 'No reading permission',
        not_pre: 'No permission',
    }
}